import K from "utilities/constants";

export default function DisplayUDF({
  fieldTypeId,
  form,
  udfId,
  title = "Title",
  isFormItem,
  isRequired = false,
  options = [],
  style = {},
  disabled = false,
  placeholder = null,
  extraLabel = null,
}) {
  const Component = K.UDF.Fields[fieldTypeId]?.displayComponent;
  const componentProps = K.UDF.Fields[fieldTypeId]?.props;

  return (
    Component && (
      <Component
        params={componentProps}
        isFormItem={isFormItem}
        form={form}
        required={isRequired}
        title={title}
        placeholder={placeholder ?? title}
        formItemName={udfId}
        options={options}
        style={style}
        disabled={disabled}
        extraLabel={extraLabel}
      />
    )
  );
}
